import React from "react";
import {Card, Grid, IconButton, List, ListItem as ListItemBase, ListItemText, Toolbar} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {Link} from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {RootGrid, HeaderTypography} from "../catalogmanager/containers/settings/containers/taxonomy";
import {pocPrimary, pageContentGap} from "../../theme";

// Relax legacy `button` prop typing on ListItem to `any` (behavior unchanged).
const ListItem: any = ListItemBase;

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

interface PartnerManagementSettingsProps {
    setTitle?: (title: string) => void;
    location: { key?: string; [key: string]: any };
    history: { push: (path: string) => void; goBack: () => void; [key: string]: any };
    [key: string]: any;
}

export default function PartnerManagementSettings(props: PartnerManagementSettingsProps) {
    React.useEffect(() => {
        if (props.setTitle) {
            props.setTitle('PMC: Settings');
        }
    }, [props]);
    return (
        <RootGrid container
              style={{padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid item container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px"}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/partnermanagementcenter");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        Settings
                    </HeaderTypography>
                </Grid>
            </Grid>
            <Grid item size={12}>
                <Card>
                    <Toolbar className='lbtoolbar'
                             style={{background: pocPrimary}}
                    >
                        Partner Management Settings
                    </Toolbar>
                    <List style={{padding: 0}}>
                        <ListItem button component={Link} to='/scorecards/options'>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Scorecards"
                                          secondary='View and manage scorecard settings.'/>
                            <ArrowForwardIosIcon color="action"/>
                        </ListItem>
                        <ListItem button component={Link} to={'/settings/sourcing'}>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Sourcing Priority"
                                          secondary='View and manage sourcing priority.'/>
                            <ArrowForwardIosIcon color="action"/>
                        </ListItem>
                        <ListItem button component={Link} to='/partnermanagementcenter/settings/suppliergroups'>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Supplier Groups"
                                          secondary='View and manage supplier groups to apply as filtered views on other pages.'/>
                            <ArrowForwardIosIcon color="action"/>
                        </ListItem>
                    </List>
                </Card>
            </Grid>
        </RootGrid>
    );
}
